import prettyBytes from "pretty-bytes";
import { Typography } from "antd";
import { Breakpoint } from "antd/lib/_util/responsiveObserve";
import { FormattedMessage } from "react-intl";

import DownloadButton from "./DownloadButton";
import { KindEnum } from "../../types/kindEnum";
import { FolderOutlined } from "@ant-design/icons";

const { Text } = Typography;

const columns = (
  datasetId: string = "",
  handleOnClick: any,
  currentPath: string
) => {
  return [
    {
      title: (
        <FormattedMessage
          id={`dataset.container.table.name`}
          defaultMessage="Nombre"
        />
      ),
      dataIndex: "name",
      key: "name",
      render: (item: any, record: any, index: any) => {
        return record?.kind === KindEnum.BLOB ? (
          record?.name
        ) : (
          <Text
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => handleOnClick(record?.name, record?.path)}
          >
            <FolderOutlined style={{ fontSize: "20px" }} />
            <Text style={{ marginLeft: "5px" }}>{record?.name}</Text>
          </Text>
        );
      },
      sorter: (a: any, b: any) => {
        return a?.name.localeCompare(b?.name);
      },
    },
    {
      title: (
        <FormattedMessage
          id={`dataset.container.table.size`}
          defaultMessage="Tamaño"
        />
      ),
      dataIndex: "properties",
      key: "properties",
      render: (item: any, record: any, index: any) => {
        return record?.kind === KindEnum.BLOB
          ? prettyBytes(record?.properties?.contentLength)
          : "";
      },
      sorter: (a: any, b: any) =>
        a?.properties?.contentLength - b?.properties?.contentLength,
      responsive: ["sm"] as Breakpoint[],
    },
    {
      title: <FormattedMessage
      id={`dataset.container.table.createdOn`}
      defaultMessage="Fecha de Creación"
    />,
      dataIndex: "properties",
      key: "properties",
      render: (item: any, record: any, index: any) => {
        return record?.kind === KindEnum.BLOB
          ? `${new Date(
              record?.properties?.createdOn
            ).toLocaleDateString()} ${new Date(
              record?.properties?.createdOn
            ).toLocaleTimeString()}`
          : "";
      },
      sorter: (a: any, b: any) =>
        new Date(a?.properties?.createdOn).getTime() -
        new Date(b?.properties?.createdOn).getTime(),
      responsive: ["sm"] as Breakpoint[],
    },
    {
      title: (
        <FormattedMessage
          id={`dataset.container.table.lastModified`}
          defaultMessage="Fecha de Actualización"
        />
      ),
      dataIndex: "properties",
      key: "properties",
      render: (item: any, record: any, index: any) => {
        return record?.kind === KindEnum.BLOB
          ? `${new Date(
              record?.properties?.lastModified
            ).toLocaleDateString()} ${new Date(
              record?.properties?.lastModified
            ).toLocaleTimeString()}`
          : "";
      },
      sorter: (a: any, b: any) =>
        new Date(a?.properties?.lastModified).getTime() -
        new Date(b?.properties?.lastModified).getTime(),
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      render: (text: any, record: any, index: any) => {
        return record?.kind === KindEnum.BLOB ? (
          <DownloadButton
            datasetId={datasetId}
            text={text}
            record={record}
            index={record.key}
            path={currentPath}
          />
        ) : (
          <></>
        );
      },
    },
  ];
};

export default columns;
